import * as React from 'react';
import Header from './Header';
import Tabs from './Tabs';
import { MENU_KEYS } from './Tabs';

export interface DetailShowProps {
  prefixCls: string;
  projectId?: string | number;
  getBodyProgress?: any;
  getBottomTabElement?: any;
  baseInfoProps?: any;
  planInfoConfig?: any;
  settleInfoConfig?: any;
  readOnly?: boolean;
}

class Show extends React.Component<DetailShowProps, any> {
  constructor(props: DetailShowProps) {
    super(props);
    this.state = {
      selectedMenu: MENU_KEYS[0].key,
    };
  }

  private handleChangeMenu = (item: any) => {
    this.setState({ selectedMenu: item.key });
  }

  private getBody = () => {
    const { getBodyProgress } = this.props;
    const { selectedMenu } = this.state;

    switch (selectedMenu) {
      case 'detail':
        return require('./Detail/index').default;
      case 'progress':
        return getBodyProgress
          ? getBodyProgress()
          : require('./Progress/index').default;
      default:
        return null;
    }
  }

  public render() {
    const {
      prefixCls,
      projectId,
      getBottomTabElement,
      baseInfoProps,
      planInfoConfig,
      settleInfoConfig,
      readOnly = true,
    } = this.props;
    const { selectedMenu } = this.state;
    const body = this.getBody();

    const className = `${prefixCls}-show`;

    return (
      <div className={className}>
        <Header prefixCls={className} />
        <Tabs
          prefixCls={className}
          selectedMenu={selectedMenu}
          handleChangeMenu={this.handleChangeMenu}
        />
        {body &&
          React.createElement(body, {
            prefixCls: className,
            projectId,
            getBottomTabElement,
            baseInfoProps,
            planInfoConfig,
            settleInfoConfig,
            readOnly,
          })}
      </div>
    );
  }
}

export default Show;
